<script type="text/javascript">
  _linkedin_partner_id = "3369377";
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(_linkedin_partner_id);
</script>
<script type="text/javascript">
  (function (l) {
    if (!l) {
      window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) };
      window.lintrk.q = []
    }
    var s = document.getElementsByTagName("script")[0];
    var b = document.createElement("script");
    b.type = "text/javascript"; b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);
</script>
<!-- <noscript>
  <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3369377&fmt=gif" />
</noscript> -->

<!-- Footer start -->
<!--*ngIf="!isUserLoggedIn"-->
<footer class="main-footer clearfix">
  <div class="footer_back2top" (click)="scrollTop()">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="44px" height="200px" viewBox="0 0 44 200" preserveAspectRatio="none">
      <g>
        <path fill="rgba(255,255,255,1)" stroke="#ffffff" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" opacity="1" d="M 45.703505156528365 200.19885384998346 C 45.73301315307617 190.79171752929688 45.365841356073965 101.6338238086374 45.662750244140625 0.25295501947402954 C 45.52727381388346 10.878458460172016 41.63068771362305 22.985551555951435 34.041473388671875 36.57423400878906 C 24.181148529052734 56.518985748291016 1.116410493850708 75.28781127929688 0.9567615985870361 100.19087982177734 C 1.1245900392532349 125.75543975830078 23.82019805908203 145.14585876464844 34.17644691467285 165.19732666015625 C 41.07911682128906 178.5620574951172 45.73301315307617 190.79171752929688 45.703505156528365 200.19885384998346 Z" transform="matrix(1 0 0 1 -0.729369 -0.220138)" style="fill: rgb(54, 54, 56); stroke: rgb(54, 54, 56);"></path>
      </g>
    </svg>
    <span class="gt3_svg_line_icon fa fa-chevron-up" style="color: rgb(255, 255, 255);"></span>
    <a style="cursor:pointer" class="gt3_back2top show"></a>
  </div>
  <div class="container footer-top">

    <!--<div class="row">
        <div class="col-sm-6">
            <a href="#" [routerLink]="['/']" class="footer-logo">
                <img src="assets/img/logos/logo-white.png" alt="footer-logo">
            </a>
            <p class="info-text">
                B+E is a modern investment brokerage firm, specializing in net lease real estate and 1031 exchanges. We help clients buy and sell single tenant real estate. Founded by deeply experienced brokers, B+E redefines trading through an intuitive end-to-end transaction platform comprising of user-friendly dashboards and an AI-driven exchange - all leveraging the largest data set in the net lease industry.
                <br><br>
                Complementing senior talent with exceptional technology, B+E's proprietary process affords greater speed, unrivaled transaction efficiencies, and stronger asset value. With offices in New York, Atlanta, Chicago, San Francisco and Tampa, our brokers trade property for our clients across the US. B+E allows virtually anyone to confidently trade net lease real estate.

                </p>
            </div>
            <div class="col-sm-6">
                <label class="sub-label">Subscribe our Newsletter</label>
                <p class="info-text">
                    Keep me posted on the latest B+E Listings, News, and Research.
                </p>
                <div id="mauticform_wrapper_newsletter" class="mauticform_wrapper">
                    <form class="ftr-subscribe" ngNoForm autocomplete="false" (ngSubmit)="onSubmit($event)" role="form" method="post" action="https://mautic.benetlease.com/form/submit?formId=2" id="mauticform_newsletter" data-mautic-form="newsletter" enctype="multipart/form-data">
                    <form class="ftr-subscribe" id="mauticForm">
                        <div class="mauticform-error" id="mauticform_newsletter_error"></div>
                        <div class="mauticform-message" id="mauticform_newsletter_message"></div>
                        <div class="mauticform-innerform">
                            <div class="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">
                                <div id="mauticform_newsletter_email" class="mauticform-row mauticform-text mauticform-field-1">
                                    <input id="mauticform_input_newsletter_email" autocomplete="off" [(ngModel)]="subscriptionEmail" (keyup)="checksubscriptionEmail($event);" placeholder="Email Address " name="mauticform[email]" value="" class="form-control" type="text" />
                                    <button type="submit" name="mauticform[submit]" (click)="onSubscription();" [disabled]="invalidSubscriptionEmail ||  subscriptionEmail ==='' || isUserLoggedIn " id="mauticform_input_newsletter_submit" name="mauticform[submit]" value="" class="subscribe-btn" value="1">Subscribe</button>
                                    <p class="redtext" *ngIf="invalidSubscriptionEmail && subscriptionEmail !=='' && !isUserLoggedIn" style="text-align:left">Invalid Email Address </p>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" name="mauticform[formId]" id="mauticform_newsletter_id" value="2" />
                        <input type="hidden" name="mauticform[return]" id="mauticform_newsletter_return" value="" />
                        <input type="hidden" name="mauticform[formName]" id="mauticform_newsletter_name" value="newsletter" />
                    </form>
                </div>
            </div>
        </div>
    </div>-->
    <div class="row">
      <div class="col-md-3 col-sm-6 footer-item clearfix">
        <div>
          <a (click)="Validation.redirect('/')" class="footer-logo">
            <img src="assets/img/logos/logo-white.png" alt="footer-logo">
          </a>
          <p class="about-be">B+E is a modern investment brokerage firm, specializing in net lease real estate and 1031 exchanges.</p>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 footer-item clearfix">
        <div class="footer-item-content margin-bottom-10">
          <h3 class="widget-title">Quick Links</h3>
          <ul class="ftr-links">
            <li *ngIf="isUserLoggedIn"><a (click)="Validation.redirect('/',null, false)">Home</a></li>
            <li><a href="#" [routerLink]="['/propertylisting']" [queryParams]="{ request:'buy' }">Buy</a></li>
            <li><a (click)="Validation.redirect('sell')">Sell</a></li>
            <li><a (click)="Validation.redirect('1031-trade','pages/trade-1031')">1031 Trade</a></li>
            <li><a (click)="Validation.redirect('insights','pages/insights')">B+E Insights</a></li>
            <li><a (click)="Validation.redirect('privacy-policy','pages/privacy')">Privacy Policy</a></li>
            <li><a (click)="Validation.redirect('terms-and-conditions','pages/terms')" style="margin-right:15px;">Terms and Conditions</a></li>
          </ul>



          <div class="clearfix"></div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 footer-item clearfix">
        <div class="footer-item-content">
          <h3 class="widget-title">ABOUT US</h3>
          <ul class="ftr-links">
            <li><a (click)="Validation.redirect('about-us/be-team','pages/about-us/be-team')">B+E Team</a></li>
            <li><a (click)="Validation.redirect('about-us/our-services','pages/about-us/our-services')">Our Services</a></li>
            <li><a (click)="Validation.redirect('about-us/join-our-team','pages/about-us/join-our-team')">Join Our Team</a></li>
            <li><a (click)="Validation.redirect('about-us/contact-us','pages/about-us/contact-us')"> Contact Us</a></li>
          </ul>



          <div class="clearfix"></div>


        </div>
      </div>

      <!--<div class="col-md-3 col-sm-3 footer-item clearfix centrfooter">
          <div class="footer-item-content socialouter">
              <h6>About Us</h6>
              <ul class="ftr-links">
                  <li><a>ABOUT US</a></li>
                  <li><a href="#" [routerLink]="['pages/about-us/our-story']"> Our Story & Leadership Team</a></li>
                  <li><a href="#" [routerLink]="['pages/about-us/join-our-team']">Join Our Team</a></li>
                  <li><a href="#" [routerLink]="['pages/about-us/press-and-news']"> Press and News</a></li>
                  <li><a href="#" [routerLink]="['pages/about-us/contact-us']"> Contact Us</a></li>
              </ul>


          </div>
      </div>-->

      <div class="col-md-3 col-sm-6 footer-item clearfix right-footer ">
        <div class="socialouter footer-item-content">
          <ul class="ftr-links">
            <li><a href="mailto:info@tradenetlease.com"><i class="fa fa-envelope" style="padding-right: 17px;"></i> info&#64;tradenetlease.com</a></li>
            <li><a href="javascript:void(0);" style="cursor:none;pointer-events:none;"><i class="fa fa-mobile-phone" style="padding-right: 17px;font-size:26px;"></i> 646-770-0659</a></li>
            <li><a href="javascript:void(0);" style="cursor:none;pointer-events:none;"><i class="fa fa-map-marker" style="padding-right: 17px;"></i>  41 Madison Ave, Floor 31, <br />  New York, NY 10010</a></li>



          </ul>
          <ul class="socialul">
            <li><a target="_blank" href="https://www.linkedin.com/company/benetlease"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a></li>
            <li><a target="_blank" href="https://www.facebook.com/BeNetLease"><i class="fa fa-facebook-square" aria-hidden="true"></i></a></li>
            <li><a target="_blank" href="https://twitter.com/BeNetLease"><i class="fa fa-twitter-square" aria-hidden="true"></i></a></li>
            <li><a target="_blank" href="https://www.instagram.com/benetlease/?igshid=N2ZiY2E3YmU%3D"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
          </ul>
          <!--<ul class="ftr-links" *ngIf="_auth0.GetUploadedImages()!=null">
      <li *ngFor="let prop of _auth0.GetUploadedImages();let i = index">
        <a>{{prop.documentName}}-{{prop.ImageGuid=='Success'?'Sucesss':'Progress'}}</a>
      </li>

    </ul>-->
        </div>
        <button id="button-basic" type="button" (click)="openSubscribeModal(templateSubscribe,'commonmodal')" class="btn-lg btn-border btn adduserbtn margin-top-10 ftr-sub-btn pull-left btn-subscribe" aria-controls="dropdown-basic">Email Preferences</button>
      </div>

      <div class="be-floating-box be-floating-box-details" id="be-floating-box1" *ngIf="_auth0.imagesList!=null&&_auth0.imagesList!=undefined&&_auth0.imagesList[0]!=null&&_auth0.imagesList[0].ImageGuid!=null&&_auth0.router.url.indexOf('viewproperty') > -1">
        <h3 class="heading1">
          <span *ngIf="_auth0.CompletedImageCount!=_auth0.totalImageCount&&_auth0.FailedImageCount<=0"> {{_auth0.CompletedImageCount}} of {{_auth0.totalImageCount}} files uploaded</span>
          <span *ngIf="_auth0.CompletedImageCount!=_auth0.totalImageCount&&_auth0.FailedImageCount>0"> {{_auth0.CompletedImageCount}} of {{_auth0.totalImageCount}} files uploaded, {{_auth0.FailedImageCount}} files failed</span>
          <span *ngIf="_auth0.CompletedImageCount==_auth0.totalImageCount&&_auth0.CompletedImageCount!=1">{{_auth0.CompletedImageCount}} files uploaded</span>
          <span *ngIf="_auth0.CompletedImageCount==_auth0.totalImageCount&&_auth0.CompletedImageCount==1">{{_auth0.CompletedImageCount}} file uploaded</span>
          <button type="button" class="close pull-right margin-left-15" aria-label="Close" (click)="OnClose(template,'Image-Uploading-Close');" *ngIf="_auth0.OngoingImageCount<=0">
            <span aria-hidden="true">&times;</span>
          </button>
          <i class="fa fa-angle-down pull-right cursor-pointor" (click)="OnCollapse(true)" *ngIf="_auth0.showImageStatus"></i>
          <i class="fa fa-angle-up pull-right cursor-pointor" (click)="OnCollapse(false)" *ngIf="_auth0.showImageStatus==false"></i>

        </h3>
        <div class="file-wrapper">
          <table class="table basictable row-border hover" *ngIf="_auth0.showImageStatus">
            <tr *ngFor="let prop of _auth0.imagesList;let i = index" class="filelisttable">
              <td class="whitespacenowrap">
                <p>
                  <a href="javascript:void(0);" (click)="OnRedirection(prop.PropertyGuid,prop.sourceUrl)" class="blueone">
                    {{prop.documentName}}
                    <p style="color:red;font-size:11px !important;" *ngIf="prop.ImageStatus!=null&&prop.ImageStatus=='Failed'">( Please click the file to Retry )</p>
                  </a>
                </p>
              </td>
              <td class="whitespacenowrap">
                <div class="displayinlineblockdiv" *ngIf="prop.ImageStatus!=null&&prop.ImageStatus!=''&&prop.ImageStatus=='Success'">
                  <i style="color:green!important" class="imageicon fa fa-check-circle" aria-hidden="true"></i>
                </div>
                <div class="displayinlineblockdiv" *ngIf="prop.ImageStatus==null||prop.ImageStatus==''">
                  <i class="imageicon fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                </div>
                <div class="displayinlineblockdiv" *ngIf="prop.ImageStatus!=null&&prop.ImageStatus=='Failed'">
                  <i class="imageicon fa fa-exclamation-triangle" style="color:red!important" aria-hidden="true"></i>
                </div>
              </td>
            </tr>
          </table>
        </div>


      </div>


      <div class="be-floating-box" id="be-floating-box1" *ngIf="_auth0.imagesList!=null&&_auth0.imagesList!=undefined&&_auth0.imagesList[0]!=null&&_auth0.imagesList[0].ImageGuid!=null&&_auth0.router.url.indexOf('viewproperty') <=-1">
        <h3 class="heading1">
          <span *ngIf="_auth0.CompletedImageCount!=_auth0.totalImageCount&&_auth0.FailedImageCount<=0"> {{_auth0.CompletedImageCount}} of {{_auth0.totalImageCount}} files uploaded</span>
          <span *ngIf="_auth0.CompletedImageCount!=_auth0.totalImageCount&&_auth0.FailedImageCount>0"> {{_auth0.CompletedImageCount}} of {{_auth0.totalImageCount}} files uploaded, {{_auth0.FailedImageCount}} files failed</span>
          <span *ngIf="_auth0.CompletedImageCount==_auth0.totalImageCount&&_auth0.CompletedImageCount!=1">{{_auth0.CompletedImageCount}} files uploaded</span>
          <span *ngIf="_auth0.CompletedImageCount==_auth0.totalImageCount&&_auth0.CompletedImageCount==1">{{_auth0.CompletedImageCount}} file uploaded</span>
          <button type="button" class="close pull-right margin-left-15" aria-label="Close" (click)="OnClose(template,'Image-Uploading-Close');" *ngIf="_auth0.OngoingImageCount<=0">
            <span aria-hidden="true">&times;</span>
          </button>
          <i class="fa fa-angle-down cursor-pointor pull-right" (click)="OnCollapse(true)" *ngIf="_auth0.showImageStatus"></i>
          <i class="fa fa-angle-up cursor-pointor pull-right" (click)="OnCollapse(false)" *ngIf="_auth0.showImageStatus==false"></i>

        </h3>
        <div class="file-wrapper">
          <table class="table basictable row-border hover" *ngIf="_auth0.showImageStatus">
            <tr *ngFor="let prop of _auth0.imagesList;let i = index" class="filelisttable">
              <td class="whitespacenowrap">
                <p>
                  <a href="javascript:void(0);" (click)="OnRedirection(prop.PropertyGuid,prop.sourceUrl)" class="blueone">
                    {{prop.documentName}}
                    <p style="color:red;font-size:11px !important;" *ngIf="prop.ImageStatus!=null&&prop.ImageStatus=='Failed'">( Please click the file to Retry )</p>
                  </a>
                </p>
              </td>
              <td class="whitespacenowrap">
                <div class="displayinlineblockdiv" *ngIf="prop.ImageStatus!=null&&prop.ImageStatus!=''&&prop.ImageStatus=='Success'">
                  <i style="color:green!important" class="imageicon fa fa-check-circle" aria-hidden="true"></i>
                </div>
                <div class="displayinlineblockdiv" *ngIf="prop.ImageStatus==null||prop.ImageStatus==''">
                  <i class="imageicon fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                </div>
                <div class="displayinlineblockdiv" *ngIf="prop.ImageStatus!=null&&prop.ImageStatus=='Failed'">
                  <i class="imageicon fa fa-exclamation-triangle" style="color:red!important" aria-hidden="true"></i>
                </div>

              </td>
            </tr>
          </table>
        </div>


      </div>


    </div>
  </div>
  <div class="footer-btm">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 text-center">
          <p class="copyrighttext">Copyright &#169; 2023 B+E</p>
        </div>
      </div>
    </div>
  </div>


</footer>
<ng-template #template>

  <div class="modal-body flag-modal">
    <div class="form-group">
      <h6 class="displayvalue" style="font-weight: 500 !important;margin-bottom: 30px;margin-top: 30px;">You have failed file uploads, are you sure you want to continue?</h6>
      <button type="button" class="close" (click)="modalClose.hide();" style="top: -35px;"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="text-right">

      <button class="btn btn-lg btn-default" (click)="modalClose.hide();">No</button>
      <button class="btn btn-lg  btn-primary" (click)="ConfirmClosing();modalClose.hide();">Yes</button>
    </div>
  </div>
</ng-template>
<!-- Footer end-->
<!--Subscribe popup-->
<ng-template #templateSubscribe>
  <form id="mc4wp-form-1" class="mc4wp-form mc4wp-form-29" method="post" data-id="29" data-name="">
    <div class="mc4wp-form-fields newsletter-modal">
      <div class="news-icon text-center">
        <img src="/assets/img/subscribe.png">

        <button type="button" class="close pull-right" aria-label="Close" (click)="modalSubscribeRef.hide()" style="color: #666;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <p class="info-text text-center margin-bottom-10">Keep me posted on the latest B+E Listings, News, and Research.</p>
      <div class="ftr-subscribe">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <label class="form-label">Email Address<span class="red">*</span></label>
            <input type="email" name="EMAIL" [(ngModel)]="email" required="" (change)="emailValidate()">
            <p class="redtext" *ngIf="!isValidEmail">
              Please enter a valid email
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-12 col-md-6 col-lg-6">
            <label class="form-label">First Name<span class="red">*</span></label>
            <input type="text" name="FNAME" [(ngModel)]="firstName" (change)="validatione(1)">
            <p class="redtext" *ngIf="!validFname">
              First name is required
            </p>
          </div>
          <div class="col-6 col-sm-12 col-md-6 col-lg-6">
            <label class="form-label">Last Name<span class="red">*</span></label>
            <input type="text" name="LNAME" [(ngModel)]="lastName" (change)="validatione(2)">
            <p class="redtext" *ngIf="!validLname">
              Last name is required
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <input class="subscribe-btn" type="submit" value="Subscribe" (click)="subscribe();">
          </div>
        </div>
      </div>
    </div><label style="display: none !important;">Leave this field empty if you're human: <input type="text" name="_mc4wp_honeypot" value="" tabindex="-1" autocomplete="off"></label><input type="hidden" name="_mc4wp_timestamp" value="1571911810"><input type="hidden" name="_mc4wp_form_id" value="29"><input type="hidden" name="_mc4wp_form_element_id" value="mc4wp-form-1"><div class="mc4wp-response"></div>
  </form>
</ng-template>

